export default __webpack_public_path__ + "static/media/lightbox.428fc88f.svg";